import { useMemo } from 'react'
import scheduleApi from 'src/api/calendarApi'
import { WEEK_DAYS } from 'src/libs/constant'
import { createRangeTimeOptions } from 'src/libs/date'
import { useGetData } from './useGetData'

/**
 *
 * @param {String} type - loại lịch (REGULAR / DEMO). Default: DEMO
 * @param {Boolean} idIsKey - Nếu là true value của option trả về là slot_id. Ngược lại value của option trả về là startTime
 * @returns {Array}
 * - Array trả về sẽ là mảng có cấu trúc như sau: [{ value: String | Number, id: Number, label: String }]
 */
export default function useGetHourOptionsByType (type = 'DEMO', idIsKey = true) {
  const { data } = useGetData(scheduleApi.hourLearning, type, {
    isDisabled: !type
  })
  const hourSorted = data?.sort((a, b) => a.startTime - b.startTime) || []
  return createRangeTimeOptions(hourSorted, { optionLabelFormat: 'START - END', optionValueByKey: idIsKey ? 'id' : 'startTime' })
}

/**
 *
 * @param {String} type - loại lịch (REGULAR / DEMO). Default: DEMO
 * @returns {Object} - Trả về đối tượng weekdays có cấu trúc:
 * {
 *    [DAY]: {
 *      id: String,
 *      startTime: Number,
 *      endTime: Number,
 *    }, { ... }
 * }
 * DAY - key những ngày trong tuần. VD: MONDAY, TUESDAY, WEDNESDAY...
 * id - là slot_id sử dụng request lên backend đăng ký lịch (khung giờ)
 * startTime - là thời gian trong ngày hệ quy đổi phút. Ví dụ: startTime = 610 là: 10 giờ 10 phút sáng
 * endTime - là thời gian trong ngày hệ quy đổi phút. Ví dụ: endTime = 680 là: 11 giờ 20 phút sáng
 */
export function useGetTimeLearningByType (type = 'DEMO', studyProgramId) {
  const payload = useMemo(() => {
    return {
      type,
      studyProgramId
    }
  }, [type, studyProgramId])
  const { data: timeLearningData } = useGetData(scheduleApi.timeLearning, payload)

  const listTimes = useMemo(() => {
    if (!timeLearningData) {
      return {}
    }
    const weekDays = {}
    WEEK_DAYS.forEach((day) => {
      const scheduleHoursOfDay = timeLearningData.filter((data) => data.dayOfWeek === day)
      weekDays[day] = scheduleHoursOfDay.sort((a, b) => a.startTime - b.startTime)
    })
    return weekDays
  }, [timeLearningData])

  return listTimes
}

export function useGetTimeLearningByTypeV2 (type = 'DEMO', studyProgramId, options= {}, dependencies = []) {
  const payload = useMemo(() => {
    return {
      type,
      studyProgramId
    }
  }, [type, studyProgramId])
  const { data: timeLearningData, reload } = useGetData(scheduleApi.timeLearning, payload, options, dependencies)

  const listTimes = useMemo(() => {
    if (!timeLearningData) {
      return {}
    }
    const weekDays = {}
    WEEK_DAYS.forEach((day) => {
      const scheduleHoursOfDay = timeLearningData.filter((data) => data.dayOfWeek === day)
      weekDays[day] = scheduleHoursOfDay.sort((a, b) => a.startTime - b.startTime)
    })
    return weekDays
  }, [timeLearningData])

  return {listTimes, reload}
}
